import { Phone } from "lucide-react";
import { useSiteData } from "@/context/SiteDataContext";
import { waLink, waPhone } from "@/lib/api";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { EnquiryDialog } from "./EnquiryDialog";

export const callLink = (settings) => `tel:+${waPhone(settings.whatsapp)}`;

export const MobileCtaBar = ({ packageId = "", tripType = "", waText = "Hi Ocean Wings Travel, I'm planning an Andaman trip. Please share details.", prefix = "mobile-cta" }) => {
  const { settings } = useSiteData();
  return (
    <>
      <div className="lg:hidden fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur px-3 py-2.5 grid grid-cols-[auto_1fr_1.2fr] gap-2" data-testid={`${prefix}-bar`}>
        <a href={callLink(settings)} aria-label="Call Ocean Wings Travel" data-testid={`${prefix}-call`}
          className="h-11 w-11 rounded-full border border-slate-200 grid place-items-center text-navy active:bg-slate-100"><Phone className="h-4 w-4" /></a>
        <a href={waLink(settings.whatsapp, waText)} target="_blank" rel="noreferrer" data-testid={`${prefix}-whatsapp`}
          className="h-11 rounded-full bg-emerald-500 text-white text-sm font-semibold inline-flex items-center justify-center gap-1.5"><WhatsAppIcon className="h-4 w-4" /> WhatsApp</a>
        <EnquiryDialog packageId={packageId} tripType={tripType} idPrefix={`${prefix}-enquiry`}
          trigger={<button type="button" data-testid={`${prefix}-quote`} className="h-11 rounded-full bg-ocean text-white text-sm font-semibold">Get Free Quote</button>} />
      </div>
      <div className="lg:hidden h-16" />
    </>
  );
};
